import { SavedSearchResponse } from '@doda/api-client/aspida/@types';
import { FeaturedSearchConditionQuery } from 'components/SearchSideBar/types';
import { convertIncomeValueToQuery } from 'components/SearchSideBar/logics/createQuery/incomeQuery';

interface ArgumentType {
  savedSearchCondition?: SavedSearchResponse | undefined;
  featuredSearchCondition?: FeaturedSearchConditionQuery | undefined;
  haQuery: string[] | undefined;
}

/**
 * id配列を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.haQuery クエリパラメータ
 * @returns 年収（下限）の初期値を取得
 */
export const getInitialLowerId = ({
  savedSearchCondition,
  featuredSearchCondition,
  haQuery,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition)
    return (
      convertIncomeValueToQuery(savedSearchCondition.lowerLimitIncome) ??
      '指定しない'
    );

  // 特集枠検索条件
  if (featuredSearchCondition)
    return (
      convertIncomeValueToQuery(featuredSearchCondition.lowerLimitIncome) ??
      '指定しない'
    );

  // クエリから取得した検索条件
  return haQuery?.at(0) ?? '指定しない';
};

/**
 * id配列を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.haQuery クエリパラメータ
 * @returns 年収（上限）の初期値を取得
 */
export const getInitialUpperId = ({
  savedSearchCondition,
  featuredSearchCondition,
  haQuery,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition) {
    return (
      convertIncomeValueToQuery(savedSearchCondition.upperLimitIncome) ??
      '指定しない'
    );
  }

  // 特集枠検索条件
  if (featuredSearchCondition) {
    return (
      convertIncomeValueToQuery(featuredSearchCondition.upperLimitIncome) ??
      '指定しない'
    );
  }

  // クエリから取得した検索条件
  return haQuery?.at(-1) ?? '指定しない';
};
